import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listLossRateSettings } from '@ebalance/proto/bffuser/v1/loss_rate_service-LossRateService_connectquery'
import {
  ListLossRateSettingsRequestSchema,
  type ListLossRateSettingsResponse,
} from '@ebalance/proto/bffuser/v1/loss_rate_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useListLossRateSettings(): UseQueryResult<
  ListLossRateSettingsResponse,
  ConnectError
> {
  return useQuery(
    listLossRateSettings,
    create(ListLossRateSettingsRequestSchema, {}),
    { throwOnError: false },
  )
}
